var _circle, _circle2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesignScoreNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "#DD6B20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_875_35379",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0032,
    cy: 14,
    r: 14,
    fill: "#A0AEC0"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_875_35379)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9041 16.1681C14.9041 16.1681 14.0873 16.2014 13.8268 16.4619C13.7229 16.5658 13.6645 16.7067 13.6645 16.8537C13.6645 17.0006 13.7229 17.1415 13.8268 17.2454C13.9307 17.3493 14.0716 17.4077 14.2185 17.4077C14.3654 17.4077 14.5064 17.3493 14.6103 17.2454C14.8708 16.9849 14.9041 16.1681 14.9041 16.1681ZM12.4968 13.1733L14.3733 13.1733V15.0497M14.9276 15.1888L14.9276 11.6867L14.3752 11.6867L14.3752 12.619L12.3578 12.619C12.1325 12.6131 11.9425 12.8031 11.9425 13.0342L11.9425 15.1888C11.9425 15.3024 11.9895 15.4082 12.064 15.4826C12.1384 15.557 12.2442 15.604 12.3578 15.604L14.5123 15.604C14.7434 15.604 14.9334 15.414 14.9276 15.1888Z",
    fill: "#932C00"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3057 6.76651C24.3057 6.76651 23.4889 6.79981 23.2284 7.06032C23.1245 7.16421 23.0661 7.30512 23.0661 7.45205C23.0661 7.59898 23.1245 7.7399 23.2284 7.84379C23.3323 7.94769 23.4732 8.00605 23.6201 8.00605C23.7671 8.00605 23.908 7.94769 24.0119 7.84379C24.2724 7.58329 24.3057 6.76651 24.3057 6.76651ZM21.8984 3.77168L23.7749 3.77168V5.6481M24.3292 5.78717L24.3292 2.28504L23.7768 2.28504L23.7768 3.21738L21.7594 3.21738C21.5341 3.2115 21.3441 3.40149 21.3441 3.63262L21.3441 5.78717C21.3441 5.90078 21.3911 6.00654 21.4656 6.08097C21.54 6.1554 21.6458 6.20241 21.7594 6.20241L23.9139 6.20241C24.1451 6.20241 24.335 6.01242 24.3292 5.78717Z",
    fill: "#932C00"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6049 11.4672C19.6049 11.4672 18.7881 11.5005 18.5276 11.761C18.4237 11.8649 18.3653 12.0058 18.3653 12.1527C18.3653 12.2997 18.4237 12.4406 18.5276 12.5445C18.6315 12.6484 18.7724 12.7067 18.9193 12.7067C19.0662 12.7067 19.2072 12.6484 19.3111 12.5445C19.5716 12.284 19.6049 11.4672 19.6049 11.4672ZM17.1976 8.47237L19.0741 8.47237V10.3488M19.6284 10.4879L19.6284 6.98572L19.076 6.98572L19.076 7.91806L17.0586 7.91806C16.8333 7.91218 16.6433 8.10218 16.6433 8.3333L16.6433 10.4879C16.6433 10.6015 16.6903 10.7072 16.7648 10.7817C16.8392 10.8561 16.945 10.9031 17.0586 10.9031L19.2131 10.9031C19.4442 10.9031 19.6342 10.7131 19.6284 10.4879Z",
    fill: "#932C00"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50244 25.5697C5.50244 25.5697 4.68567 25.603 4.42517 25.8635C4.32127 25.9674 4.2629 26.1083 4.2629 26.2553C4.2629 26.4022 4.32127 26.5431 4.42517 26.647C4.52906 26.7509 4.66997 26.8093 4.8169 26.8093C4.96383 26.8093 5.10474 26.7509 5.20864 26.647C5.46915 26.3865 5.50244 25.5697 5.50244 25.5697ZM3.09522 22.5749L4.97164 22.5749V24.4513M5.52595 24.5904L5.52595 21.0883L4.9736 21.0883L4.9736 22.0206L2.95615 22.0206C2.7309 22.0147 2.54091 22.2047 2.54091 22.4358L2.54091 24.5904C2.54091 24.704 2.58792 24.8098 2.66235 24.8842C2.73678 24.9586 2.84255 25.0056 2.95615 25.0056L5.11071 25.0056C5.34183 25.0056 5.53182 24.8156 5.52595 24.5904Z",
    fill: "#932C00"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2032 20.8691C10.2032 20.8691 9.38648 20.9024 9.12597 21.1629C9.02208 21.2668 8.96371 21.4077 8.96371 21.5546C8.96371 21.7015 9.02208 21.8424 9.12597 21.9463C9.22987 22.0502 9.37078 22.1086 9.51771 22.1086C9.66464 22.1086 9.80555 22.0502 9.90945 21.9463C10.17 21.6858 10.2032 20.8691 10.2032 20.8691ZM7.79602 17.8742L9.67244 17.8742V19.7506M10.2268 19.8897L10.2268 16.3876L9.6744 16.3876L9.6744 17.3199L7.65696 17.3199C7.43171 17.314 7.24172 17.504 7.24172 17.7352L7.24172 19.8897C7.24172 20.0033 7.28872 20.1091 7.36315 20.1835C7.43758 20.2579 7.54335 20.305 7.65696 20.305L9.81151 20.305C10.0426 20.305 10.2326 20.115 10.2268 19.8897Z",
    fill: "#932C00"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6561 13.8178C26.6561 13.8178 25.8393 13.8511 25.5788 14.1116C25.4749 14.2155 25.4165 14.3564 25.4165 14.5033C25.4165 14.6503 25.4749 14.7912 25.5788 14.8951C25.6827 14.999 25.8236 15.0573 25.9705 15.0573C26.1175 15.0573 26.2584 14.999 26.3623 14.8951C26.6228 14.6346 26.6561 13.8178 26.6561 13.8178ZM24.2488 10.823L26.1253 10.823V12.6994M26.6796 12.8384L26.6796 9.33631L26.1272 9.33631L26.1272 10.2686L24.1098 10.2686C23.8845 10.2628 23.6945 10.4528 23.6945 10.6839L23.6945 12.8384C23.6945 12.952 23.7415 13.0578 23.816 13.1322C23.8904 13.2067 23.9962 13.2537 24.1098 13.2537L26.2643 13.2537C26.4955 13.2537 26.6854 13.0637 26.6796 12.8384Z",
    fill: "#932C00"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.9555 18.5187C21.9555 18.5187 21.1387 18.552 20.8782 18.8125C20.7743 18.9164 20.716 19.0573 20.716 19.2043C20.716 19.3512 20.7743 19.4921 20.8782 19.596C20.9821 19.6999 21.123 19.7583 21.27 19.7583C21.4169 19.7583 21.5578 19.6999 21.6617 19.596C21.9222 19.3355 21.9555 18.5187 21.9555 18.5187ZM19.5483 15.5239L21.4247 15.5239V17.4003M21.979 17.5394L21.979 14.0372L21.4267 14.0372L21.4267 14.9696L19.4092 14.9696C19.184 14.9637 18.994 15.1537 18.994 15.3848L18.994 17.5394C18.994 17.653 19.041 17.7587 19.1154 17.8332C19.1898 17.9076 19.2956 17.9546 19.4092 17.9546L21.5638 17.9546C21.7949 17.9546 21.9849 17.7646 21.979 17.5394Z",
    fill: "#932C00"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip7_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2545 23.2194C17.2545 23.2194 16.4377 23.2527 16.1772 23.5132C16.0733 23.6171 16.0149 23.758 16.0149 23.9049C16.0149 24.0519 16.0733 24.1928 16.1772 24.2967C16.2811 24.4006 16.422 24.4589 16.5689 24.4589C16.7158 24.4589 16.8568 24.4006 16.9607 24.2967C17.2212 24.0362 17.2545 23.2194 17.2545 23.2194ZM14.8472 20.2246L16.7237 20.2246V22.101M17.278 22.2401L17.278 18.7379L16.7256 18.7379L16.7256 19.6703L14.7082 19.6703C14.4829 19.6644 14.2929 19.8544 14.2929 20.0855L14.2929 22.2401C14.2929 22.3537 14.3399 22.4594 14.4144 22.5339C14.4888 22.6083 14.5946 22.6553 14.7082 22.6553L16.8627 22.6553C17.0938 22.6553 17.2838 22.4653 17.278 22.2401Z",
    fill: "#932C00"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip8_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 27.9203C12.5537 27.9203 11.7369 27.9536 11.4764 28.2141C11.3725 28.318 11.3141 28.4589 11.3141 28.6059C11.3141 28.7528 11.3725 28.8937 11.4764 28.9976C11.5803 29.1015 11.7212 29.1599 11.8681 29.1599C12.015 29.1599 12.156 29.1015 12.2598 28.9976C12.5204 28.7371 12.5537 27.9203 12.5537 27.9203ZM10.1464 24.9255L12.0228 24.9255V26.8019M12.5772 26.941L12.5772 23.4388L12.0248 23.4388L12.0248 24.3712L10.0074 24.3712C9.78211 24.3653 9.59212 24.5553 9.59212 24.7864L9.59212 26.941C9.59212 27.0546 9.63913 27.1604 9.71356 27.2348C9.78799 27.3092 9.89376 27.3562 10.0074 27.3562L12.1619 27.3562C12.393 27.3562 12.583 27.1662 12.5772 26.941Z",
    fill: "#932C00"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip9_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2545 4.41593C17.2545 4.41593 16.4377 4.44923 16.1772 4.70973C16.0733 4.81363 16.0149 4.95454 16.0149 5.10147C16.0149 5.2484 16.0733 5.38931 16.1772 5.49321C16.2811 5.5971 16.422 5.65547 16.5689 5.65547C16.7158 5.65547 16.8568 5.5971 16.9607 5.49321C17.2212 5.2327 17.2545 4.41593 17.2545 4.41593ZM14.8472 1.4211L16.7237 1.4211V3.29752M17.278 3.43659L17.278 -0.0655447L16.7256 -0.0655448L16.7256 0.86679L14.7082 0.86679C14.4829 0.860914 14.2929 1.05091 14.2929 1.28203L14.2929 3.43659C14.2929 3.55019 14.3399 3.65596 14.4144 3.73039C14.4888 3.80482 14.5946 3.85183 14.7082 3.85183L16.8627 3.85183C17.0938 3.85183 17.2838 3.66183 17.278 3.43659Z",
    fill: "#932C00"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5537 9.11686C12.5537 9.11686 11.7369 9.15015 11.4764 9.41066C11.3725 9.51455 11.3141 9.65547 11.3141 9.8024C11.3141 9.94933 11.3725 10.0902 11.4764 10.1941C11.5803 10.298 11.7212 10.3564 11.8681 10.3564C12.015 10.3564 12.156 10.298 12.2598 10.1941C12.5204 9.93363 12.5537 9.11686 12.5537 9.11686ZM10.1464 6.12203L12.0228 6.12203V7.99845M12.5772 8.13751L12.5772 4.63538L12.0248 4.63538L12.0248 5.56772L10.0074 5.56772C9.78211 5.56184 9.59212 5.75183 9.59212 5.98296L9.59212 8.13751C9.59212 8.25112 9.63913 8.35689 9.71356 8.43132C9.78799 8.50575 9.89376 8.55275 10.0074 8.55275L12.1619 8.55275C12.393 8.55275 12.583 8.36276 12.5772 8.13751Z",
    fill: "#932C00"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip11_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.85285 13.8178C7.85285 13.8178 7.03607 13.8511 6.77557 14.1116C6.67167 14.2155 6.61331 14.3564 6.61331 14.5033C6.61331 14.6503 6.67167 14.7912 6.77557 14.8951C6.87946 14.999 7.02038 15.0573 7.16731 15.0573C7.31424 15.0573 7.45515 14.999 7.55904 14.8951C7.81955 14.6346 7.85285 13.8178 7.85285 13.8178ZM5.44562 10.823L7.32204 10.823V12.6994M7.87635 12.8384L7.87635 9.33631L7.324 9.33631L7.324 10.2686L5.30655 10.2686C5.08131 10.2628 4.89131 10.4528 4.89131 10.6839L4.89131 12.8384C4.89131 12.952 4.93832 13.0578 5.01275 13.1322C5.08718 13.2067 5.19295 13.2537 5.30655 13.2537L7.46111 13.2537C7.69223 13.2537 7.88223 13.0637 7.87635 12.8384Z",
    fill: "#932C00"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip12_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1518 18.5185C3.1518 18.5185 2.33502 18.5518 2.07452 18.8123C1.97062 18.9162 1.91226 19.0571 1.91226 19.204C1.91226 19.3509 1.97062 19.4918 2.07452 19.5957C2.17841 19.6996 2.31933 19.758 2.46626 19.758C2.61319 19.758 2.7541 19.6996 2.85799 19.5957C3.1185 19.3352 3.1518 18.5185 3.1518 18.5185ZM0.744571 15.5236L2.62099 15.5236V17.4001M3.1753 17.5391L3.1753 14.037L2.62295 14.037L2.62295 14.9693L0.605504 14.9693C0.380255 14.9635 0.190263 15.1534 0.190263 15.3846L0.190263 17.5391C0.190263 17.6527 0.237271 17.7585 0.311701 17.8329C0.386131 17.9074 0.4919 17.9544 0.605504 17.9544L2.76006 17.9544C2.99118 17.9544 3.18118 17.7644 3.1753 17.5391Z",
    fill: "#932C00"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip13_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.497 2.35953C10.497 2.35953 9.68024 2.39283 9.41973 2.65333C9.31584 2.75723 9.25747 2.89814 9.25747 3.04507C9.25747 3.192 9.31584 3.33291 9.41973 3.43681C9.52363 3.5407 9.66454 3.59907 9.81147 3.59907C9.9584 3.59907 10.0993 3.5407 10.2032 3.43681C10.4637 3.1763 10.497 2.35953 10.497 2.35953ZM8.08979 -0.635299L9.96621 -0.635299V1.24112M10.5205 1.38019L10.5205 -2.12194L9.96817 -2.12194L9.96817 -1.18961L7.95072 -1.18961C7.72547 -1.19548 7.53548 -1.00549 7.53548 -0.774365L7.53548 1.38019C7.53548 1.49379 7.58249 1.59956 7.65692 1.67399C7.73135 1.74842 7.83712 1.79543 7.95072 1.79543L10.1053 1.79543C10.3364 1.79543 10.5264 1.60544 10.5205 1.38019Z",
    fill: "#932C00"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip14_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.79621 7.06022C5.79621 7.06022 4.97943 7.09351 4.71893 7.35402C4.61503 7.45791 4.55667 7.59883 4.55667 7.74576C4.55667 7.89269 4.61503 8.0336 4.71893 8.13749C4.82282 8.24139 4.96374 8.29976 5.11067 8.29976C5.2576 8.29976 5.39851 8.24139 5.5024 8.13749C5.76291 7.87699 5.79621 7.06022 5.79621 7.06022ZM3.38898 4.06538L5.2654 4.06538V5.94181M5.81971 6.08087L5.81971 2.57874L5.26736 2.57874L5.26736 3.51108L3.24991 3.51108C3.02466 3.5052 2.83467 3.69519 2.83467 3.92632L2.83467 6.08087C2.83467 6.19448 2.88168 6.30025 2.95611 6.37468C3.03054 6.44911 3.13631 6.49611 3.24991 6.49611L5.40447 6.49611C5.63559 6.49611 5.82559 6.30612 5.81971 6.08087Z",
    fill: "#932C00"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip15_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.0954 11.7611C1.0954 11.7611 0.278627 11.7944 0.0181224 12.0549C-0.085773 12.1588 -0.14414 12.2998 -0.144141 12.4467C-0.144141 12.5936 -0.085773 12.7345 0.0181224 12.8384C0.122017 12.9423 0.262929 13.0007 0.409859 13.0007C0.556789 13.0007 0.697701 12.9423 0.801597 12.8384C1.0621 12.5779 1.0954 11.7611 1.0954 11.7611ZM-1.31183 8.76631L0.564596 8.76631V10.6427M1.1189 10.7818L1.1189 7.27967L0.566554 7.27967L0.566554 8.212L-1.45089 8.212C-1.67614 8.20613 -1.86613 8.39612 -1.86613 8.62725L-1.86613 10.7818C-1.86613 10.8954 -1.81913 11.0012 -1.7447 11.0756C-1.67027 11.15 -1.5645 11.197 -1.45089 11.197L0.703662 11.197C0.934787 11.197 1.12478 11.007 1.1189 10.7818Z",
    fill: "#932C00"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip16_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.0065 20.8691C29.0065 20.8691 28.1897 20.9024 27.9292 21.1629C27.8253 21.2668 27.7669 21.4077 27.7669 21.5546C27.7669 21.7015 27.8253 21.8424 27.9292 21.9463C28.0331 22.0502 28.174 22.1086 28.3209 22.1086C28.4679 22.1086 28.6088 22.0502 28.7127 21.9463C28.9732 21.6858 29.0065 20.8691 29.0065 20.8691ZM26.5992 17.8742L28.4757 17.8742V19.7506M29.03 19.8897L29.03 16.3876L28.4776 16.3876L28.4776 17.3199L26.4602 17.3199C26.2349 17.314 26.0449 17.504 26.0449 17.7352L26.0449 19.8897C26.0449 20.0033 26.0919 20.1091 26.1664 20.1835C26.2408 20.2579 26.3466 20.305 26.4602 20.305L28.6147 20.305C28.8459 20.305 29.0359 20.115 29.03 19.8897Z",
    fill: "#932C00"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip17_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3057 25.5697C24.3057 25.5697 23.4889 25.603 23.2284 25.8635C23.1245 25.9674 23.0661 26.1083 23.0661 26.2553C23.0661 26.4022 23.1245 26.5431 23.2284 26.647C23.3323 26.7509 23.4732 26.8093 23.6201 26.8093C23.7671 26.8093 23.908 26.7509 24.0119 26.647C24.2724 26.3865 24.3057 25.5697 24.3057 25.5697ZM21.8984 22.5749L23.7749 22.5749V24.4513M24.3292 24.5904L24.3292 21.0883L23.7768 21.0883L23.7768 22.0206L21.7594 22.0206C21.5341 22.0147 21.3441 22.2047 21.3441 22.4358L21.3441 24.5904C21.3441 24.704 21.3911 24.8098 21.4656 24.8842C21.54 24.9586 21.6458 25.0056 21.7594 25.0056L23.9139 25.0056C24.1451 25.0056 24.335 24.8156 24.3292 24.5904Z",
    fill: "#932C00"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip18_875_35379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.6049 30.2707C19.6049 30.2707 18.7881 30.304 18.5276 30.5645C18.4237 30.6684 18.3653 30.8093 18.3653 30.9562C18.3653 31.1031 18.4237 31.244 18.5276 31.3479C18.6315 31.4518 18.7724 31.5102 18.9193 31.5102C19.0662 31.5102 19.2072 31.4518 19.3111 31.3479C19.5716 31.0874 19.6049 30.2707 19.6049 30.2707ZM17.1976 27.2758L19.0741 27.2758V29.1523M19.6284 29.2913L19.6284 25.7892L19.076 25.7892L19.076 26.7215L17.0586 26.7215C16.8333 26.7156 16.6433 26.9056 16.6433 27.1368L16.6433 29.2913C16.6433 29.4049 16.6903 29.5107 16.7648 29.5851C16.8392 29.6596 16.945 29.7066 17.0586 29.7066L19.2131 29.7066C19.4442 29.7066 19.6342 29.5166 19.6284 29.2913Z",
    fill: "#932C00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(14.1196 9.50952) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(23.5212 0.10791) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(18.8204 4.80859) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(4.71796 18.9111) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(9.41876 14.2104) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(25.8716 7.15918) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(21.171 11.8601) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip7_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(16.47 16.5608) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip8_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(11.7692 21.2617) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip9_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(16.47 -2.24268) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(11.7692 2.45825) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip11_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(7.06836 7.15918) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip12_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(2.36731 11.8599) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip13_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(9.71252 -4.29907) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip14_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(5.01172 0.401611) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip15_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(0.310913 5.10254) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip16_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(28.222 14.2104) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip17_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(23.5212 18.9111) rotate(45)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip18_875_35379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.648,
    height: 6.648,
    fill: "white",
    transform: "translate(18.8204 23.6121) rotate(45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignScoreNormal);
export default __webpack_public_path__ + "static/media/DesignScoreNormal.8bc7b6544e33e929e73738c3438d4338.svg";
export { ForwardRef as ReactComponent };